import { createContext } from 'react'

import { ETestData } from 'shared/lib/testData'

export const DynamicInputContext = createContext<{ testData?: ETestData }>({})
